import veritoneApi from './veritoneApi';
import moment from 'moment-timezone'
import  { AD_TYPE_ID } from './constant'

export function getCampaignApi(urlApi, id) {
    return veritoneApi(urlApi.baseUrl)
        .get(`${urlApi.campaign}/${id}`)
        .then(response => response.data.campaign)
        .catch(error => ({
            error: true,
            ...error
        }))
}

export function removeCampaignApi(urlApi, id) {
    return veritoneApi(urlApi.baseUrl)
        .delete(`${urlApi.campaign}/${id}`)
        .then(response => response)
        .catch(error => ({
            error: true,
            ...error
        }))
}

export function addCampaignApi(urlApi, campaign) {
    return veritoneApi(urlApi.baseUrl)
        .post(
            `${urlApi.campaign}/`,
            campaign
        )
        .then(response => response.data.campaign)
        .catch(error => ({
            error: true,
            ...error
        }))
}

export function updateCampaignApi(urlApi, campaign) {
    return veritoneApi(urlApi.baseUrl)
        .put(
            `${urlApi.campaign}/${campaign.campaign_id}`,
            campaign
        )
        .then(response => {
            return (
                response.data.campaign
            )
        })
        .catch(error => ({
            error: true,
            ...error
        }))
}

// TODO: Ask Dat if we are still using this API.
export function getCalendarDataApi(urlApi, campaign_id) {
    const timeZone = moment.tz.guess()
    return veritoneApi(urlApi.baseUrl)
        .get(
            `${urlApi.campaign}/${campaign_id}/calendar?timeZone=${timeZone}`
        )
        .then(response => {
            return response.data.data
        })
        .catch(error => ({
            error: true,
            ...error
        }))
}

export function removeCreativeApi(urlApi, campaign_id, creative) {
    return veritoneApi(urlApi.baseUrl)
        .put(
            `${urlApi.campaign}/${campaign_id}/removeCreative`,
            creative
        )
        .then(response => {
            return (
                response
            )
        })
        .catch(error => ({
            error: true,
            ...error
        }))
}


export function undoCreativeApi(urlApi, campaign_id, creative) {
    return veritoneApi(urlApi.baseUrl)
        .put(
            `${urlApi.campaign}/${campaign_id}/undoRemoveCreative`,
            creative
        )
        .then(response => {
            return (
                response
            )
        })
        .catch(error => ({
            error: true,
            ...error
        }))
}

export function updateCampaignDrilldownApi (urlApi, campaign_id, drilldown) {
    return veritoneApi(urlApi.baseUrl)
        .put(
            `${urlApi.campaign}/${campaign_id}/drillDown`, drilldown
        )
        .then(
            response => {
                return response
            }
        )
        .catch(
            error => ({
                error: true,
                ...error
            })
        )
}

export function getReassignApi(urlApi, advertiserId, campaignId, chartId, startDate, endDate) {
    return veritoneApi(urlApi.baseUrl)
        .get(`/advertiser/${advertiserId}/data/${campaignId}?startDate=${startDate}&endDate=${endDate}&chartIds=${chartId}&typeIds=${AD_TYPE_ID["Pre-recorded Spots"]}`)
        .then(response => response.data)
        .catch(error => error)
}

export function getDataDrillDownChangingApi( urlApi, campaign_id) {
    return veritoneApi(urlApi.baseUrl)
        .get(
            `${urlApi.campaign}/${campaign_id}/drillDown`
        )
        .then(
            response => {
                return response.data
            }
        )
        .catch(
            error => ({
                error: true,
                ...error
            })
        )
}

export function updatePermissionsAPI(apiUrls, campaignId, permissions) {
  return veritoneApi(apiUrls.baseUrl)
    .post(`${apiUrls.campaign}/${campaignId}/share`, permissions)
    .then(response => response.data)
    .catch(error => ({error: true, ...error}));
}

export function refreshCampaignDataAPI(apiUrls, campaignId) {
    return veritoneApi(apiUrls.baseUrl)
      .get(`${apiUrls.campaign}/refresh/${campaignId}`)
      .then(response => response.data)
      .catch(error => ({error: true, ...error}));
}

/**
 * Load campaign data for the selected campaignIds
 * @param {{baseUrl: string, campaign: string}} apiUrls 
 * @param {Array<number>} campaignIds (Default value is [])
 * - If campaignIds is an empty array. This function will load all campaigns user can access to
 * @param {number} chunkSize (Default value is 7)
 * - if chunkSize is less than or equal 0. This function will load everything in bulk
 */
export function loadCampaignsAPI(apiUrls, campaignIds = [], chunkSize = 7) {
  if (chunkSize <= 0) {
    //Load all campaigns at once
    const idsQueryString = campaignIds.reduce((accumulator, id) => {
      return `${accumulator}&campaigns[]=${id}`;
    }, '');
  
    return veritoneApi(apiUrls.baseUrl)
      .get(`${apiUrls.campaign}?${idsQueryString}`)
      .then(response => response.data)
      .catch(error => ({error: true, ...error}));
  } else {
    //Load campaigns by small chunks to avoid overloading the server & request timeout
    return new Promise(async (resolve, reject) => {
      const result = await loadCampaignsByChunks(apiUrls, campaignIds, chunkSize);
      resolve(result);
    });
  }
}

/**
 * Recursively load campaigns by small chunks
 * @param {{baseUrl: string, campaign: string}} apiUrls 
 * @param {Array<number>} campaignIds 
 * @param {number} chunkSize
 */
async function loadCampaignsByChunks(apiUrls, campaignIds = [], chunkSize = 7) {
  const leftOverIds = [...campaignIds];
  const fetchingIds = leftOverIds.splice(0, chunkSize);
  const idsQueryString = fetchingIds.reduce((accumulator, id) => {
    return `${accumulator}&campaigns[]=${id}`;
  }, '');

  try {
    const response = await veritoneApi(apiUrls.baseUrl).get(`${apiUrls.campaign}?${idsQueryString}`);
    const responseData = response.data;
    
    //Validate response data
    if (!Array.isArray(responseData.data)) {
      throw new Error('invalid response');
    }

    // Continue loading other campaigns
    if (leftOverIds && leftOverIds.length > 0) {
      const otherResponses = await loadCampaignsByChunks(apiUrls, leftOverIds, chunkSize);
      if (!otherResponses.error) {
        responseData.data = [...responseData.data, ...otherResponses.data];         //merge response data
      } else {
        return otherResponses;
      }
    }

    return responseData;
  } catch (error) {
    return { error: true, ...error }
  }
}

/**
 * Get all mention in data_store_mention for the selected campaignId and hashWindow
 * @param {{baseUrl: string}} urlApi 
 * @param {string} campaignId 
 * @param {string} hashWindow 
 */
export function getCampaignLastMentionApi(urlApi, campaignId, hashWindow) {
    return veritoneApi(urlApi.baseUrl)
        .get(`${urlApi.campaign}/lastMention/${campaignId}/${hashWindow}`)
        .then(response => response.data)
        .catch(error => ({
            error: true,
            ...error
        }))
}

/**
 * Get processing percentage for selected campaignId and hashWindow
 * @param {{baseUrl: string}} urlApi
 * @param {string} campaignId
 * @param {string} hashWindow
 */
export function getCalculatedPercentage(urlApi, campaignId, body) {
    return veritoneApi(urlApi.baseUrl)
        .post(`${urlApi.campaign}/${campaignId}/calculateProcess`, body)
        .then(response => response.data)
        .catch(error => ({
            error: true,
            ...error
        }))
}

/**
 * Get hash history of a campaign
 * @param {{baseUrl: string}} urlApi 
 * @param {string} campaignId 
 */
 export function getCampaignHashHistoryApi(urlApi, campaignId) {
    return veritoneApi(urlApi.baseUrl)
        .get(`${urlApi.campaign}/${campaignId}/hash`)
        .then(response => response.data)
        .catch(error => ({
            error: true,
            ...error
        }))
}

export function getCampaignErrorApi({
    urlApi, 
    campaignId, 
    limit = 50, 
    offset = 0, 
    hashWindow
}) {
    let queryString = `campaignId=${campaignId}&limit=${limit}&offset=${offset}`;
    if (hashWindow) {
        queryString += `&hashWindow=${hashWindow}`
    }
    return veritoneApi(urlApi.baseUrl)
        .get(`/errors_log/campaign/?${queryString}`)
        .then(response => response.data)
        .catch(error => ({
            error: true,
            ...error
        }))
}
